// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import WeiboSquareFilledSvg from "@ant-design/icons-svg/es/asn/WeiboSquareFilled";
import AntdIcon from '../components/AntdIcon';

var WeiboSquareFilled = function WeiboSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: WeiboSquareFilledSvg
  }));
};

WeiboSquareFilled.displayName = 'WeiboSquareFilled';
export default React.forwardRef(WeiboSquareFilled);